// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1ZAo7","loaderOuter":"PageOverlayLoader_loaderOuter__3B10K"};